import { subscription } from 'nike-re-framejs';

export const transactionHistoryReports$ = subscription(db =>
    db.getIn(['transaction', 'reports', 'transactionHistory'])
);
export const transactionHistoryHasMore$ = subscription(db => db.getIn(['transaction', 'reports', 'hasMore']));
export const transactionHistoryCurrency$ = subscription(db => db.getIn(['transaction', 'reports', 'currency']));
